import styled from '@emotion/styled'

import { SwitchWithLabel } from '../../atoms/switch-label/index'

export type StrategySelection = 'yes' | 'no' | 'unavailable'

export type StrategyProps = {
  name: string
  onChange: (v: boolean) => void
  readonly?: boolean
  selected: StrategySelection
}

const StyledStrategyBlock = styled.div`
  padding: 0 16px 8px;
  margin: 0 0 8px;
  border-bottom: dotted 1px var(--White90);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:last-of-type {
    border-bottom: none;
  }

  label {
    color: var(--Graphite);
    font-weight: normal;
    margin: 0;
  }
`

export const StrategyItem = ({ name, onChange, readonly, selected }: StrategyProps) => (
  <StyledStrategyBlock>
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label>{name}</label>
    <SwitchWithLabel
      isChecked={selected === 'yes'}
      isDisabled={readonly || selected === 'unavailable'}
      isDisabledShownAsUnavailable={!readonly}
      size="medium"
      onChange={onChange}
    />
  </StyledStrategyBlock>
)
